module.exports = __webpack_public_path__ + "img/promo-1.0d6108a8.png";